import { ScopeSection } from '@app/features/scope-overview/model/scope-section'
import { createAction, props } from '@ngrx/store'
import { ChangeItem } from '../../model'

export enum ChangeRequestSectionActionTypes {
  ADD_SECTION = '[Change Request] Add Section',
  ADD_SECTION_SUCCESS = '[Change Request] Add Section Success',
  ADD_SECTION_FAIL = '[Change Request] Add Section Fail',
  DELETE_SECTION = '[Change Request] Delete Section',
  DELETE_SECTION_SUCCESS = '[Change Request] Delete Section Success',
  DELETE_SECTION_FAIL = '[Change Request] Delete Section Fail',
}

const addSection = createAction(ChangeRequestSectionActionTypes.ADD_SECTION, props<{ data: ScopeSection }>())
const addSectionSuccess = createAction(
  ChangeRequestSectionActionTypes.ADD_SECTION_SUCCESS,
  props<{ changeItem: ChangeItem }>()
)
const addSectionFail = createAction(ChangeRequestSectionActionTypes.ADD_SECTION_FAIL, props<{ error: Error }>())

const deleteSection = createAction(ChangeRequestSectionActionTypes.DELETE_SECTION, props<{ sectionId: number }>())
const deleteSectionSuccess = createAction(
  ChangeRequestSectionActionTypes.DELETE_SECTION_SUCCESS,
  props<{ changeItem: ChangeItem }>()
)
const deleteSectionFail = createAction(ChangeRequestSectionActionTypes.DELETE_SECTION_FAIL, props<{ error: Error }>())

export const ChangeRequestSectionActions = {
  addSection,
  addSectionSuccess,
  addSectionFail,
  deleteSection,
  deleteSectionSuccess,
  deleteSectionFail,
}
